import { IoIosSettings } from "react-icons/io";
import { HiDocumentText } from "react-icons/hi";
import { MdOutlineCampaign } from "react-icons/md";
import { RiChatForwardFill } from "react-icons/ri";
import { FaWallet } from "react-icons/fa";
import NavBarItem from "./NavBar/NavBarItem";
// import { UserContext } from "../../context/UserContext";
// import { useContext } from "react";
import { BsLink45Deg } from "react-icons/bs";
import { TbReportSearch } from "react-icons/tb";
import { FaFolderOpen } from "react-icons/fa";
import { FaWpforms } from "react-icons/fa6";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../context/UserContext";
import { useNavCounts } from "../../context/NavbarContext";
import { Box, Stack } from "@mui/material";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import AccessAlarmIcon from "@mui/icons-material/AccessAlarm";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
const NavBar = () => {
  const { user } = useContext(UserContext);
  const { navCounts, requestNavCounts } = useNavCounts();
  const openWebIntakeCount = navCounts.openWebIntakes;
  const validationCount = navCounts.validations;
  const [reminderCount, setReminderCount] = useState(0);

  useEffect(() => {
    requestNavCounts();
  }, [requestNavCounts]);

  return (
    <div className="p-2 flex flex-col">
      {user?.role === "admin" &&
        [
          "desanctisj@oaklandthrive.org",
          "garcias@oaklandthrive.org",
          "cookt@oaklandthrive.org",
          "williamst@oaklandthrive.org",
          "admin",
        ].includes(user.username) && (
          <Stack direction="row" sx={{ alignItems: "center" }} spacing={0}>
            <NavBarItem
              toURL={"/dashboard/webIntakeForms"}
              icon={<FaWpforms />}
              text={"Web Intake Forms"}
            />
            {openWebIntakeCount > 0 && (
              <Box
                sx={{
                  backgroundColor: "red",
                  color: "white",
                  borderRadius: "50%",
                  width: 20,
                  height: 20,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 12,
                  fontWeight: "bold",
                }}
              >
                {openWebIntakeCount}
              </Box>
            )}
          </Stack>
        )}

      <Stack direction="row" sx={{ alignItems: "center" }} spacing={0}>
        <NavBarItem
          newTab={true}
          toURL={"/dashboard/validations"}
          icon={<AssignmentIndIcon />}
          text={"Data Validations"}
        />
        {validationCount > 0 && (
          <Box
            sx={{
              backgroundColor: "red",
              color: "white",
              borderRadius: "50%",
              width: 20,
              height: 20,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 12,
              fontWeight: "bold",
            }}
          >
            !
          </Box>
        )}
      </Stack>
      <Stack direction="row" sx={{ alignItems: "center" }} spacing={0}>
        <NavBarItem
          toURL={"/dashboard"}
          icon={<HiDocumentText />}
          text={"Dashboard"}
        />
        {reminderCount > 0 && (
          <Box
            sx={{
              backgroundColor: "red",
              color: "white",
              borderRadius: "50%",
              width: 20,
              height: 20,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 12,
              fontWeight: "bold",
            }}
          >
            {reminderCount}
          </Box>
        )}
      </Stack>
      <NavBarItem
        newTab={true}
        toURL={"https://linktr.ee/OaklandThriveMI"}
        icon={<BsLink45Deg />}
        text={"Internal Links"}
      />

      <NavBarItem
        toURL={"/dashboard/firms"}
        icon={<HiDocumentText />}
        text={"New Firm Visit Plan"}
      />
      <NavBarItem
        toURL={"/dashboard/exploreFirm"}
        icon={<FaWallet />}
        text={"Explore Firms"}
      />
      <NavBarItem
        toURL={"/dashboard/myreferrals"}
        icon={<RiChatForwardFill />}
        text={"My Referrals"}
      />
      <NavBarItem
        toURL={"/dashboard/providers"}
        icon={<FaWallet />}
        text={"B2B Providers"}
      />
      <NavBarItem
        toURL={"/dashboard/resources"}
        icon={<IoIosSettings />}
        text={"Resource Partners"}
      />
      <NavBarItem
        toURL={"/dashboard/events"}
        icon={<IoIosSettings />}
        text={"Events"}
      />
      <NavBarItem
        toURL={"/dashboard/glossary"}
        icon={<RiChatForwardFill />}
        text={"Glossary of Terms"}
      />

      <NavBarItem
        toURL={"/dashboard/reports"}
        icon={<TbReportSearch />}
        text={"Reporting"}
      />

      <NavBarItem
        toURL={"/dashboard/archivedcases"}
        icon={<FaFolderOpen />}
        text={"Archived Cases"}
      />
      <NavBarItem
        toURL={"/dashboard/broadcast"}
        icon={<MdOutlineCampaign />}
        text={"Broadcast Email"}
      />
      <NavBarItem
        toURL={"/dashboard/support"}
        icon={<SupportAgentIcon />}
        text={"Support"}
      />
    </div>
  );
};

export default NavBar;
